module.exports = __webpack_public_path__ + "static/media/lavinesp.e089f959.png";